import g from './pass2'

export default '3OssFOc0UKX' + g
